import React, { useReducer } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";

// Custom.
import { ProtectedRoute } from "@vocollege/components";
import { reducer } from "@vocollege/app/dist/modules/VoHelpers";
import { VoAppContext, initialState } from "services/GlobalState";
import {
  stylesCommon,
  stylesToast,
  stylesLayout,
  stylesGlobal,
  stylesActions,
} from "@vocollege/theme";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import VoLoader from "@vocollege/components/dist/VoLoader";
import AuthGuard from "pages/auth/AuthGuard";
import ErrorBoundary from "pages/auth/ErrorBoundary";
import routes from "pages/routes";
import Header from "containers/Layout/Header";
import strings from "@vocollege/app/dist/modules/Services/I18n/strings.json";
import vocertStrings from "api/strings.json";

// Add VoCert strings to I18n.
let newStrings = { ...strings, ...vocertStrings };
I18n.set(newStrings);

const useStylesCommon = makeStyles(() => stylesCommon);
const useStylesToast = makeStyles(() => stylesToast);
const useStylesLayout = makeStyles(() => stylesLayout);
const useStylesGlobal = makeStyles(() => stylesGlobal);
const useStylesActions = makeStyles(() => stylesActions);

const App = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  useStylesCommon();
  useStylesToast();
  useStylesLayout();
  useStylesGlobal();
  useStylesActions();
  return (
    <BrowserRouter>
      <React.Suspense fallback={<VoLoader />}>
        <ErrorBoundary>
          <VoAppContext.Provider value={{ state, dispatch }}>
            <AuthGuard>
              {!state.hideHeader && <Header />}
              <Routes>
                <Route path={routes.auth.path} />
                <Route
                  path={routes.login.path}
                  element={<routes.login.component />}
                />
                <Route
                  path={routes.diplomas.path}
                  element={
                    <ProtectedRoute
                      path={routes.diplomas.path}
                      component={routes.diplomas.component}
                      abilities={routes.diplomas.abilities}
                    />
                  }
                />
                <Route
                  path={routes["diplomas.id"].path}
                  element={
                    <ProtectedRoute
                      path={routes["diplomas.id"].path}
                      component={routes["diplomas.id"].component}
                      abilities={routes["diplomas.id"].abilities}
                    />
                  }
                />
                <Route
                  path={routes.certificates.path}
                  element={
                    <ProtectedRoute
                      path={routes.certificates.path}
                      component={routes.certificates.component}
                      abilities={routes.certificates.abilities}
                    />
                  }
                />
                <Route
                  path={routes["certificates.id"].path}
                  element={
                    <ProtectedRoute
                      path={routes["certificates.id"].path}
                      component={routes["certificates.id"].component}
                      abilities={routes["certificates.id"].abilities}
                    />
                  }
                />
                <Route
                  path={routes.tutorCertificates.path}
                  element={
                    <ProtectedRoute
                      path={routes.tutorCertificates.path}
                      component={routes.tutorCertificates.component}
                      abilities={routes.tutorCertificates.abilities}
                    />
                  }
                />
                <Route
                  path={routes["tutorCertificates.id"].path}
                  element={
                    <ProtectedRoute
                      path={routes["tutorCertificates.id"].path}
                      component={routes["tutorCertificates.id"].component}
                      abilities={routes["tutorCertificates.id"].abilities}
                    />
                  }
                />
                <Route
                  path={routes.tutorAwardCertificates.path}
                  element={
                    <ProtectedRoute
                      path={routes.tutorAwardCertificates.path}
                      component={routes.tutorAwardCertificates.component}
                      abilities={routes.tutorAwardCertificates.abilities}
                    />
                  }
                />
                <Route
                  path={routes["tutorAwardCertificates.id"].path}
                  element={
                    <ProtectedRoute
                      path={routes["tutorAwardCertificates.id"].path}
                      component={routes["tutorAwardCertificates.id"].component}
                      abilities={routes["tutorAwardCertificates.id"].abilities}
                    />
                  }
                />
                <Route
                  path={routes.careAssistantDiplomas.path}
                  element={
                    <ProtectedRoute
                      path={routes.careAssistantDiplomas.path}
                      component={routes.careAssistantDiplomas.component}
                      abilities={routes.careAssistantDiplomas.abilities}
                    />
                  }
                />
                <Route
                  path={routes["careAssistantDiplomas.id"].path}
                  element={
                    <ProtectedRoute
                      path={routes["careAssistantDiplomas.id"].path}
                      component={routes["careAssistantDiplomas.id"].component}
                      abilities={routes["careAssistantDiplomas.id"].abilities}
                    />
                  }
                />
                <Route
                  path={routes.ambassadorCertificates.path}
                  element={
                    <ProtectedRoute
                      path={routes.ambassadorCertificates.path}
                      component={routes.ambassadorCertificates.component}
                      abilities={routes.ambassadorCertificates.abilities}
                    />
                  }
                />
                <Route
                  path={routes["ambassadorCertificates.id"].path}
                  element={
                    <ProtectedRoute
                      path={routes["ambassadorCertificates.id"].path}
                      component={routes["ambassadorCertificates.id"].component}
                      abilities={routes["ambassadorCertificates.id"].abilities}
                    />
                  }
                />
                <Route
                  path={routes.languageRepresentativeDiplomas.path}
                  element={
                    <ProtectedRoute
                      path={routes.languageRepresentativeDiplomas.path}
                      component={
                        routes.languageRepresentativeDiplomas.component
                      }
                      abilities={
                        routes.languageRepresentativeDiplomas.abilities
                      }
                    />
                  }
                />
                <Route
                  path={routes["languageRepresentativeDiplomas.id"].path}
                  element={
                    <ProtectedRoute
                      path={routes["languageRepresentativeDiplomas.id"].path}
                      component={
                        routes["languageRepresentativeDiplomas.id"].component
                      }
                      abilities={
                        routes["languageRepresentativeDiplomas.id"].abilities
                      }
                    />
                  }
                />
                <Route
                  path={routes.languageRepresentativeEducatorDiplomas.path}
                  element={
                    <ProtectedRoute
                      path={routes.languageRepresentativeEducatorDiplomas.path}
                      component={
                        routes.languageRepresentativeEducatorDiplomas.component
                      }
                      abilities={
                        routes.languageRepresentativeEducatorDiplomas.abilities
                      }
                    />
                  }
                />
                <Route
                  path={
                    routes["languageRepresentativeEducatorDiplomas.id"].path
                  }
                  element={
                    <ProtectedRoute
                      path={
                        routes["languageRepresentativeEducatorDiplomas.id"].path
                      }
                      component={
                        routes["languageRepresentativeEducatorDiplomas.id"]
                          .component
                      }
                      abilities={
                        routes["languageRepresentativeEducatorDiplomas.id"]
                          .abilities
                      }
                    />
                  }
                />
                <Route
                  path={routes.courseMoments.path}
                  element={
                    <ProtectedRoute
                      path={routes.courseMoments.path}
                      component={routes.courseMoments.component}
                      abilities={routes.courseMoments.abilities}
                    />
                  }
                />
                <Route
                  path={routes["courseMoments.id"].path}
                  element={
                    <ProtectedRoute
                      path={routes["courseMoments.id"].path}
                      component={routes["courseMoments.id"].component}
                      abilities={routes["courseMoments.id"].abilities}
                    />
                  }
                />
                <Route
                  path={routes.collegeCertificates.path}
                  element={
                    <ProtectedRoute
                      path={routes.collegeCertificates.path}
                      component={routes.collegeCertificates.component}
                      abilities={routes.collegeCertificates.abilities}
                    />
                  }
                />
                <Route
                  path={routes["collegeCertificates.id"].path}
                  element={
                    <ProtectedRoute
                      path={routes["collegeCertificates.id"].path}
                      component={routes["collegeCertificates.id"].component}
                      abilities={routes["collegeCertificates.id"].abilities}
                    />
                  }
                />

                <Route
                  path={routes.statistics.path}
                  element={
                    <ProtectedRoute
                      path={routes.statistics.path}
                      component={routes.statistics.component}
                      abilities={routes.statistics.abilities}
                    />
                  }
                />
                <Route
                  path={routes["statistics.diplomas"].path}
                  element={
                    <ProtectedRoute
                      path={routes["statistics.diplomas"].path}
                      component={routes["statistics.diplomas"].component}
                      abilities={routes["statistics.diplomas"].abilities}
                    />
                  }
                />
                <Route
                  path={routes["statistics.certificates"].path}
                  element={
                    <ProtectedRoute
                      path={routes["statistics.certificates"].path}
                      component={routes["statistics.certificates"].component}
                      abilities={routes["statistics.certificates"].abilities}
                    />
                  }
                />
                <Route
                  path={routes["statistics.tutorCertificates"].path}
                  element={
                    <ProtectedRoute
                      path={routes["statistics.tutorCertificates"].path}
                      component={
                        routes["statistics.tutorCertificates"].component
                      }
                      abilities={
                        routes["statistics.tutorCertificates"].abilities
                      }
                    />
                  }
                />
                <Route
                  path={routes["statistics.careAssistantDiplomas"].path}
                  element={
                    <ProtectedRoute
                      path={routes["statistics.careAssistantDiplomas"].path}
                      component={
                        routes["statistics.careAssistantDiplomas"].component
                      }
                      abilities={
                        routes["statistics.careAssistantDiplomas"].abilities
                      }
                    />
                  }
                />
                <Route
                  path={routes["statistics.ambassadorCertificates"].path}
                  element={
                    <ProtectedRoute
                      path={routes["statistics.ambassadorCertificates"].path}
                      component={
                        routes["statistics.ambassadorCertificates"].component
                      }
                      abilities={
                        routes["statistics.ambassadorCertificates"].abilities
                      }
                    />
                  }
                />
                <Route
                  path={
                    routes["statistics.languageRepresentativeDiplomas"].path
                  }
                  element={
                    <ProtectedRoute
                      path={
                        routes["statistics.languageRepresentativeDiplomas"].path
                      }
                      component={
                        routes["statistics.languageRepresentativeDiplomas"]
                          .component
                      }
                      abilities={
                        routes["statistics.languageRepresentativeDiplomas"]
                          .abilities
                      }
                    />
                  }
                />
                <Route
                  path={
                    routes["statistics.languageRepresentativeEducatorDiplomas"]
                      .path
                  }
                  element={
                    <ProtectedRoute
                      path={
                        routes[
                          "statistics.languageRepresentativeEducatorDiplomas"
                        ].path
                      }
                      component={
                        routes[
                          "statistics.languageRepresentativeEducatorDiplomas"
                        ].component
                      }
                      abilities={
                        routes[
                          "statistics.languageRepresentativeEducatorDiplomas"
                        ].abilities
                      }
                    />
                  }
                />
                <Route
                  path={routes["statistics.courseMoments"].path}
                  element={
                    <ProtectedRoute
                      path={routes["statistics.courseMoments"].path}
                      component={routes["statistics.courseMoments"].component}
                      abilities={routes["statistics.courseMoments"].abilities}
                    />
                  }
                />
                <Route
                  path={routes.root.path}
                  element={<routes.root.component />}
                />
              </Routes>
            </AuthGuard>
          </VoAppContext.Provider>
        </ErrorBoundary>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default App;
